import styled from 'styled-components'

import { ImageShrink, fromMd, untilMd } from '@syconium/little-miss-figgy'

export const Container = styled.section`
  margin-bottom: 32px;
  text-align: center;
  position: relative;

  ${fromMd} {
    margin-bottom: 40px;
  }
`

export const ImageWrap = styled.div`
  height: 250px;
  position: relative;
  overflow: hidden;

  ${fromMd} {
    height: 400px;
  }

  & > img,
  & > picture > img,
  & > video {
    height: 100%;
    left: 0;
    object-fit: cover;
    font-family: 'object-fit: cover;';
    position: absolute;
    top: 0;
    width: 100%;
  }
`

export const TitleWrap = styled.div<{
  textColor: string
}>`
  color: ${o => o.textColor};
  left: 40px;
  position: absolute;
  right: 40px;
  top: 50%;
  transform: translate(0, -50%);
`

export const Title = styled.h1`
  font-size: 24px;
  font-weight: bold;
  letter-spacing: 0.6px;
  line-height: 1.33;
  text-transform: uppercase;

  ${fromMd} {
    font-size: 35px;
    letter-spacing: 2px;
    line-height: 1.2;
  }
`

export const TitleImage = styled(ImageShrink)`
  display: block;
  margin: 0 auto;

  ${untilMd} {
    width: 80%;
    max-width: 250px;
  }

  ${fromMd} {
    width: 40%;
    max-width: 400px;
  }
`

export const SubtitleWrapper = styled.div`
  display: flex;
  justify-content: center;
`

export const Subtitle = styled.p`
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.6px;
  line-height: 1.69;
  margin-top: 8px;

  ${fromMd} {
    font-size: 22px;
    margin-top: 16px;
    width: 849px;
  }
`

export const Video = styled.video`
  display: block;
`

export const Description = styled.div`
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.6px;
  line-height: 1.5;
  margin: 32px 40px 0;

  ${fromMd} {
    font-size: 20px;
    letter-spacing: normal;
    line-height: 1.7;
    margin: 40px auto 0;
    width: 700px;
  }
}`

export const VimeoContainer = styled.div`
  height: 100%;
  overflow: hidden;
  position: relative;
  width: 100%;
`

export const Disclaimer = styled.div<{
  $textColor: string
}>`
  bottom: ${o => o.theme.spacing(2)};
  color: ${o => o.$textColor};
  position: absolute;
  margin-top: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  text-align: center;
  padding: 0 ${o => o.theme.spacing(1)};
  box-sizing: border-box;
`
